import React from 'react';

// Continuous ticker. The item list is rendered twice so the track can
// loop seamlessly; the duplicate is hidden from assistive tech.
function MarqueeStrip({ items }) {
  if (!items || items.length === 0) return null;

  const track = (hidden) => (
    <div className="marquee__track" aria-hidden={hidden || undefined}>
      {items.map((item) => (
        <span className="marquee__item" key={item}>
          {item}
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee">
      {track(false)}
      {track(true)}
    </div>
  );
}

export default MarqueeStrip;
